import head from 'lodash/head'
import get from 'lodash/get'

const pushNewEvent = (eventName, eventObject) => {
  if (!window.dataLayer) return

  const existing = Array.isArray(window.dataLayer)
    ? window.dataLayer.filter(dl => dl.event === eventName).pop()
    : null

  if (existing) {
    const hasNewData = Object.entries(eventObject).some(
      ([key, value]) => existing[key] !== value
    )
    if (!hasNewData) return
  }

  window.dataLayer.push({
    event: eventName,
    ...eventObject,
  })
}

const pushApplicationId = ({ id }) => {
  pushNewEvent('applicationIdcreated', { applicationId: id })
}

const pushApplicationData = ({ id, applicationType, applicationNumber, customerInformation }) => {

  const leadInformation = head(get(customerInformation, 'leadInformation'))

  const applicationData = {
    applicationId: id,
    applicationNumber,
    applicationType,
    stateCode: get(customerInformation, 'contactInformation.address.stateCode'),
    leadId: get(leadInformation, 'leadId'),
    leadSource: get(leadInformation, 'source'),
  }

  const filteredApplicationData = Object.fromEntries(
    Object.entries(applicationData).filter(([, value]) => value != null)
  )

  pushNewEvent('applicationDataCollected', filteredApplicationData)

}

const pushApplicationMetricsData  = ({ applicationID, applicationNumber, customerType, ldFlag, ldVariation }) => {
  pushNewEvent('applicationMetricsDataCollected', {
    applicationID,
    applicationNumber,
    customerType,
    ldFlag,
    ldVariation,
  })
}

const pushVirtualPageView = (
  virtualPageURL,
  virtualPageTitle,
  details = {}
) => {
  pushNewEvent('VirtualPageview', {
    virtualPageURL,
    virtualPageTitle,
    ...details,
  })
}

export default {
  pushApplicationId,
  pushApplicationData,
  pushVirtualPageView,
  pushApplicationMetricsData,
}
